module.exports = __webpack_public_path__ + "img/game-dvd-available.d2429597.png";